import {
  aYaraRule,
  aYaraSource,
  mockYaraRuleEditorOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockYaraRuleEditorOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          yaraSource: aYaraSource(),
          yaraRule: aYaraRule(),
        },
      });
    }
  ),
];
